export function markScrolled(scrollTop: number): void {
  const root = document.documentElement;
  const on = root.hasAttribute('data-scrolled');
  if (on ? scrollTop <= 0 : scrollTop > 8) root.toggleAttribute('data-scrolled', !on);
}
